import { useEffect } from 'react';

interface MetaOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(attribute: 'name' | 'property', key: string, value: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', value);
}

export default function useDocumentMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
    }
    if (keywords) {
      setMeta('name', 'keywords', keywords);
    }
    setMeta('property', 'og:title', title);
  }, [title, description, keywords]);
}